module.exports = __webpack_public_path__ + "img/longquan2.befd2c7c.png";